import { useAppStore } from 'hooks/state/useAppStore';
import { useTransitiveCacheStore } from 'hooks/state/useTransitiveCacheStore';
import { DailyDateRangePicker } from 'components/filter/input/DateRangePicker';
import type { DateValue } from 'components/filter/input/DateRangePicker/types';
import { ARTICLE_VISIBILITY_PRESET_IDS } from './presets';
import type { DateRangePickerBaseProps } from 'components/filter/input/DateRangePicker';

export function ArticleVisibilityDatePicker(props: DateRangePickerBaseProps) {
  const { creationDateRange, setCreationDateRange } = useAppStore();
  const { disabledFilters } = useTransitiveCacheStore();

  const theRange = props.selectedDateRange ?? creationDateRange;
  const setter = props.setSelectedDateRange ?? setCreationDateRange;

  const isDisabled = props.disabled ?? disabledFilters?.includes('creationDateRange') ?? false;

  const handleChange = (fullDV: DateValue) => {
    setter({ range: fullDV.range });
  };

  return (
    <DailyDateRangePicker
      caption={props.caption}
      emptyMessage={props.emptyMessage ?? 'datepicker.empty.default'}
      presetIds={ARTICLE_VISIBILITY_PRESET_IDS}
      disabled={isDisabled}
      value={{ range: theRange.range }}
      onChange={handleChange}
      hideButtons
    />
  );
}
